
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="currentColor">
  <g clip-path="url(#clip0_2902_44571)">
    <path d="M9 0C4.0206 0 0 4.0206 0 9C0 13.9794 4.0206 18 9 18C13.9794 18 18 13.9794 18 9C18 4.0206 13.9794 0 9 0ZM13.6392 9.0864L10.668 11.9196C10.452 12.126 10.281 12.051 10.281 11.7576V10.3398C10.059 10.3167 9.83585 10.3051 9.6126 10.305C8.72081 10.3028 7.83917 10.4942 7.02858 10.866C6.21798 11.2378 5.49774 11.7811 4.9176 12.4584C4.878 12.5052 4.8378 12.552 4.8 12.6C4.845 9.615 7.2702 7.2018 10.2816 7.1322L10.281 5.6778C10.281 5.3844 10.4544 5.3118 10.668 5.5158L13.6392 8.3484C13.6899 8.39557 13.7303 8.45268 13.758 8.51616C13.7856 8.57965 13.7999 8.64815 13.7999 8.7174C13.7999 8.78665 13.7856 8.85515 13.758 8.91864C13.7303 8.98212 13.6899 9.03923 13.6392 9.0864Z"/>
  </g>
  <defs>
    <clipPath id="clip0_2902_44571">
      <rect width="18" height="18"/>
    </clipPath>
  </defs>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'ExportList',
    }) as DefineComponent
    </script>
    